module.exports = __webpack_public_path__ + "static/img/layout-img@m.7d05a3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-group/layout-img@m.png
// module id = FB58
// module chunks = 0